/**
 * Api Portal AutoAtendimento
 * AutoAtendimento
 *
 * OpenAPI spec version: v1
 * Contact: helpdesk@sicred.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */


import ApiClient from '../ApiClient';





/**
* The SicredVersao model module.
* @module model/SicredVersao
* @version v1
*/
export default class SicredVersao {
    /**
    * Constructs a new <code>SicredVersao</code>.
    * @alias module:model/SicredVersao
    * @class
    */

    constructor() {
        

        
        

        

        
    }

    /**
    * Constructs a <code>SicredVersao</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/SicredVersao} obj Optional instance to populate.
    * @return {module:model/SicredVersao} The populated <code>SicredVersao</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SicredVersao();

            
            
            

            if ({}.hasOwnProperty.call(nome, "nome")) {
                obj['nome'] = ApiClient.convertToType(data['nome'], 'String');
            }
            if (({}.hasOwnProperty.call(nome, "versao"))) {
                obj['versao'] = ApiClient.convertToType(data['versao'], 'String');
            }
        }
        return obj;
    }

    /**
    * @member {String} nome
    */
    nome = undefined;
    /**
    * @member {String} versao
    */
    versao = undefined;








}


